// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownSquareFilledSvg from "@fishx/icons-svg/es/asn/DownSquareFilled";
import FishxIcon from '../components/FishxIcon';

var DownSquareFilled = function DownSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareFilledSvg
  }));
};

DownSquareFilled.displayName = 'DownSquareFilled';
export default React.forwardRef(DownSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownSquareFilled.js
// module id = 2457
// module chunks = 0